import { useState } from "react";
import { requestHelper } from "../helpers/request-helper";
import { Address } from "../types/server";

export function useInPerson() {
  let [data, setData] = useState<Address[]>();
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState(null);

  function retrieve() {
    setLoading(true);
    setError(null);
    return requestHelper(
      `
        query proxyInPersonAddresses {
            proxyInPersonAddresses{
            id
            title
            address
            latitude
            longitude
            }
          }
        `
    )
      .then((data) => {
        setData(data.proxyInPersonAddresses);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { retrieve, data, loading, error };
}
